namespace Matrix.Data {
    export class OwnershipProxyColumns {
        static columnsKey = 'Data.OwnershipProxy';
    }
}
